import api from './api';

export interface Diagnosis {
  code: string;
  Diagnosis: string;
  questionnaire?: string;
}

export const diagnosesService = {
  async searchDiagnoses(q?: string): Promise<Diagnosis[]> {
    const params = q ? `?q=${encodeURIComponent(q)}` : '';
    const response = await api.get(`/diagnoses/${params}`);
    return response.data;
  },
};
